"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class TypesenseError extends Error {
}
exports.default = TypesenseError;
//# sourceMappingURL=TypesenseError.js.map